<template>
  <div class="card-due-date footer-icon-wrap">
    <em
      :style="calendarIcon"
      class="custom-icons small-card-info-icons"
      :class="dueDateClass"
    />
    <span
      v-if="smallCard"
      class="due-date-text-small-card"
    >
      {{ dueDateText }}
    </span>
    <span
      v-else
      class="text-xs ml-2 text-text-default"
      v-text="dueDateText"
    />
  </div>
</template>

<script>
export default {
  name: 'CardDateContent',
  props: {
    dueDateClass: {
      type: String,
      required: true,
    },
    dueDateText: {
      type: String,
      required: true,
    },
    calendarIcon: {
      type: Object,
      required: true,
    },
    smallCard: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
